import styled from 'styled-components';
import {dFlex, dFlexCenter, mobileMedia} from '../../../../globalVariables/GlobalVariables';

export const container = styled.div`
    ${dFlex};
    flex-direction: column;
    flex: 1;
    min-height: 0;
    ${mobileMedia} {
        margin: 0 var(--space-lg);
        border-radius: 0;
        border: none;
        overflow: visible;
        background: transparent;
        gap: var(--space-md);
    }
`;

export const separator = styled.hr`
    border: none;
    margin: 0;
    height: 1px;
    background: var(--TA-color-border-subtle);
    ${mobileMedia} {
        display: none;
    }
`;

export const emptyState = styled.div`
    flex: 1;
    ${dFlexCenter};
    padding: var(--space-3xl);
    color: var(--TA-color-text-subtle);
    font-family: Assistant, sans-serif;
    font-size: var(--font-size-body);
`;

